import { RawCountrySpecificSetting } from 'src/app/state-management/types/configuration.type';

function getValueFromRawCountrySpecificSetting(rawSetting: RawCountrySpecificSetting) {
	switch (rawSetting.settingType) {
		case 'Boolean':
			return rawSetting.value === 'true' ? true : false;
		case 'Number':
			if (isNaN(+rawSetting.value)) {
				console.error(
					`Value ${rawSetting.value} of ${rawSetting.name} couldn't be converted to number!`,
				);
				return '';
			}
			return +rawSetting.value;
		case 'MultiSelect':
			try {
				return JSON.parse(rawSetting.value);
			} catch (error) {
				console.error(error);
				return '';
			}
		default:
			return rawSetting.value;
	}
}

export const CONFIGURATION_UTILITIES = { getValueFromRawCountrySpecificSetting };
